module.exports = "./img/42e110f906bf6ad92d63725520a95e4e.jpg";